import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { newUpdateBlueprintUseCase } from "@src/cloud-connect/blueprint/use-cases/new-update-blueprint-use-case";
import { useI18N } from "@src/language/language-context";
import { RootState } from "@src/reducers/store";
import {
  updateBlueprintModalContentShown,
  updateSelectedBlueprint,
  updateShowSaveBlueprintModal,
} from "@src/reducers/your-reducer";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useReplaceContentHook = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const selectedBluePrint = useSelector(
    (state: RootState) => state.yourSlice.saveBlueprintModal.selectedBlueprint,
  );

  const updatedBlueprintInfo = useSelector(
    (state: RootState) => state.yourSlice.updatedBlueprintInfo,
  );

  const [disableSaveButton, setDisableSaveButton] = useState(false);

  const texts = {
    successMessage: i18n("modules.replaceBlueprintModal.successMessage"),
    errorMessage: i18n("modules.replaceBlueprintModal.errorMessage"),
    errorNodeStructureForBlueprintTooManyNodes: i18n(
      "modules.replaceBlueprintModal.errorNodeStructureForBlueprintTooManyNodes",
    ),
    subTitle: i18n("modules.replaceBlueprintModal.subTitle"),
    warningIconAltText: i18n(
      "modules.replaceBlueprintModal.warningIconAltText",
    ),
    warningText: i18n("modules.replaceBlueprintModal.warningText"),
    blueprintReplaceQuestion: i18n(
      "modules.replaceBlueprintModal.blueprintReplaceQuestion",
    ),
    firstBlueprintReplacementDescriptionParagraph: i18n(
      "modules.replaceBlueprintModal.firstBlueprintReplacementDescriptionParagraph",
    ),
    secondBlueprintReplacementDescriptionParagraph: i18n(
      "modules.replaceBlueprintModal.secondBlueprintReplacementDescriptionParagraph",
    ),
    continueButton: i18n("modules.replaceBlueprintModal.continueButton"),
    cancelButton: i18n("modules.replaceBlueprintModal.cancelButton"),
  };

  const closeModal = () => {
    dispatch(updateShowSaveBlueprintModal(false));
    dispatch(updateBlueprintModalContentShown("save"));
    dispatch(updateSelectedBlueprint(undefined));
    setDisableSaveButton(false);
  };

  const backToSaveBlueprint = () => {
    dispatch(updateBlueprintModalContentShown("save"));
  };

  const handleUpdateBlueprintResponse = (response) => {
    if (response && !response.error) {
      successSnackbar(texts.successMessage, 5000);
      closeModal();
    } else if (
      response &&
      response.error &&
      response.statusCode === 422 &&
      response.message.includes("50000")
    ) {
      errorSnackbar(texts.errorNodeStructureForBlueprintTooManyNodes, 5000);
      closeModal();
    } else {
      errorSnackbar(texts.errorMessage, 5000);
      closeModal();
    }
  };

  const continueAndReplaceBlueprint = async () => {
    setDisableSaveButton(true);
    const response = await newUpdateBlueprintUseCase({
      ...selectedBluePrint,
      name: updatedBlueprintInfo.name,
      description: updatedBlueprintInfo.description,
      author: updatedBlueprintInfo.author,
    });

    handleUpdateBlueprintResponse(response);
  };

  const isContinueAndReplaceButtonDisabled = () => {
    return disableSaveButton;
  };

  return {
    selectedBluePrint,
    texts,
    closeModal,
    backToSaveBlueprint,
    continueAndReplaceBlueprint,
    isContinueAndReplaceButtonDisabled,
  };
};
